<template>
  <div class="cpo-dropdown">
    <div
      class="cpo-input"
      @click="toggleDropdown"
    >
      <input
        v-if="isOpen"
        v-model="search"
        type="text"
        :placeholder="$t('search')"
        class="cpo-search-input"
        @click.stop
      >
      <span v-else>
        {{ selectedLabel || placeholder }}
      </span>
      <span class="arrow">▾</span>
    </div>

    <ul
      v-if="isOpen"
      class="cpo-options"
    >
      <li
        v-if="filteredOptions.length"
        :key="filteredOptions[0].value ?? 'null'"
        class="cpo-option"
        @click="select(filteredOptions[0].value)"
      >
        {{ filteredOptions[0].label }}
      </li>

      <li
        v-if="!search"
        class="cpo-divider"
      >
        {{ $t('components.map.ChargerTwoStepGeocodingPopup.frequentlyUsedCPOs') }}
      </li>

      <li
        v-for="(option, index) in filteredFrequentlySelected"
        :key="option.value ?? index"
        class="cpo-option"
        @click="select(option.value)"
      >
        {{ option.label }}
      </li>

      <li
        v-if="!search"
        class="cpo-divider"
      >
        {{ $t('components.map.ChargerTwoStepGeocodingPopup.otherCPOs') }}
      </li>

      <li
        v-for="(option, index) in filteredOther"
        :key="`other-${option.value ?? index}`"
        class="cpo-option"
        @click="select(option.value)"
      >
        {{ option.label }}
      </li>

      <!-- No results -->
      <li
        v-if="filteredOptions.length === 0"
        class="cpo-option disabled"
      >
        {{ $t('components.form.select.noOptionsMessage') }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'CpoDropdown',
  directives: {
    outside: {
      beforeMount(el, binding) {
        el.clickOutsideEvent = function(event) {
          if (!(el == event.target || el.contains(event.target))) {
            binding.value(event)
          }
        }
        document.addEventListener('click', el.clickOutsideEvent)
      },
      unmounted(el) {
        document.removeEventListener('click', el.clickOutsideEvent)
      },
    },
  },
  props: {
    value: [String, Number, null],
    options: { type: Array, required: true },
    placeholder: { type: String, default: 'Select CPO...' },
    frequentlySelectedCount: { type: Number, default: 10 },
  },
  data() {
    return {
      isOpen: false,
      search: '',
    }
  },
  computed: {
    selectedLabel() {
      const selected = this.options.find(o => o.value === this.value)
      return selected ? selected.label : null
    },
    filteredOptions() {
      if (!this.search) return this.options
      const searchLower = this.search.toLowerCase()
      return this.options.filter(o => o.label.toLowerCase().includes(searchLower))
    },
    filteredFrequentlySelected() {
      return this.filteredOptions.slice(1, 1 + this.frequentlySelectedCount)
    },
    filteredOther() {
      return this.filteredOptions.slice(1 + this.frequentlySelectedCount)
    },
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen
    },
    closeDropdown() {
      this.isOpen = false
      this.search = ''
    },
    select(value) {
      this.$emit('input', value)
      this.closeDropdown()
    },
  },
}
</script>

<style scoped>
.cpo-dropdown {
  position: relative;
  width: 100%;
  font-family: sans-serif;
}

.cpo-input {
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cpo-input input.cpo-search-input {
  flex-grow: 1;
  border: none;
  outline: none;
}

.cpo-input .arrow {
  margin-left: 4px;
}

.cpo-options {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 250px;
  overflow-y: auto;
  border: 1px solid #ccc;
  background: white;
  margin: 0;
  padding: 0;
  list-style: none;
  z-index: 10;
}

.cpo-option {
  padding: 6px 8px;
  cursor: pointer;
}

.cpo-option:hover {
  background: #f0f0f0;
}

.cpo-option.disabled {
  color: #999;
  cursor: default;
}

.cpo-divider {
  padding: 4px 8px;
  font-weight: bold;
  color: #555;
  background: #f9f9f9;
  cursor: default;
}
</style>
